import React from "react";
import { useTheme } from "src/context/theme.context";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className?: string }) => (
  <div className={`h-3 rounded bg-gray-200 dark:bg-gray-600 animate-pulse ${className || ""}`} />
);

export const FunctionErrorsTableSkeleton: React.FC<Props> = ({ rows = 8 }) => {
  const { isDarkMode } = useTheme();
  const rowBg = isDarkMode ? "bg-gray-800/60" : "odd:bg-white even:bg-gray-50";
  const borderCls = isDarkMode ? "border-gray-700" : "border-gray-200";

  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className={`text-left ${rowBg}`}>
          <td className={`px-4 py-3 border-t ${borderCls}`}>
            <Cell className="w-32" />
          </td>
          <td className={`px-4 py-3 border-t ${borderCls}`}>
            <Cell className="max-w-xs" />
          </td>
          <td className={`px-4 py-3 border-t ${borderCls}`}>
            <Cell className="w-16" />
          </td>
          <td className={`px-4 py-3 border-t ${borderCls} text-center`}>
            <Cell className="w-10 mx-auto" />
          </td>
          <td className={`px-4 py-3 border-t ${borderCls} text-center`}>
            <Cell className="w-8 mx-auto" />
          </td>
          <td className={`px-4 py-3 border-t ${borderCls}`}>
            <div className="flex flex-col gap-1">
              <Cell className="w-24" />
              <Cell className="w-24" />
            </div>
          </td>
        </tr>
      ))}
    </>
  );
};
